import {assertPartialSchema, createAction, useSelector, v} from '../../../lib'
import {reorderByPartialItems} from '../../../lib/ordering'

import {
  IMethod,
  ITask,
  ITaskSchedule,
  ITaskEventTracker,
  IQuestionnaire,
  ITaskScheduleReminder,
} from '../../../shared/db'

export enum MethodActionType {
  METHOD_SET = 'METHOD_SET',
  METHOD_DELETE = 'METHOD_DELETE',
  METHOD_ADD_TASK = 'METHOD_ADD_TASK',
  METHOD_UPDATE_TASK = 'METHOD_UPDATE_TASK',
  METHOD_UPDATE_TASK_SCHEDULE_LIST = 'METHOD_UPDATE_TASK_SCHEDULE_LIST',
  METHOD_ADD_TASK_SCHEDULE = 'METHOD_CREATE_TASK_SCHEDULE',
  METHOD_UPDATE_TASK_SCHEDULE = 'METHOD_UPDATE_TASK_SCHEDULE',
  METHOD_UPDATE_TASK_SCHEDULE_REMINDER_LIST = 'METHOD_UPDATE_TASK_SCHEDULE_REMINDER_LIST',
  METHOD_DELETE_TASK_SCHEDULE = 'METHOD_DELETE_TASK_SCHEDULE',
  METHOD_ADD_TASK_EVENT_TRACKER = 'METHOD_ADD_TASK_EVENT_TRACKER',
  METHOD_UPDATE_TASK_EVENT_TRACKER = 'METHOD_UPDATE_TASK_EVENT_TRACKER',
  METHOD_DELETE_TASK_EVENT_TRACKER = 'METHOD_DELETE_TASK_EVENT_TRACKER',
  METHOD_UPDATE_TASK_ENABLE_STATUS = 'METHOD_UPDATE_TASK_ENABLE_STATUS',
  METHOD_DELETE_TASK = 'METHOD_DELETE_TASK',
  METHOD_TASK_LIST_UPDATE = 'METHOD_TASK_LIST_UPDATE',
  METHOD_TASK_LIST_ORDER_UPDATE = 'METHOD_TASK_LIST_ORDER_UPDATE',
  METHOD_GARMIN_CONNECT_ENABLE_UPDATE = 'METHOD_GARMIN_CONNECT_ENABLE_UPDATE',
  METHOD_GARMIN_STREAM_ENABLE_UPDATE = 'METHOD_GARMIN_STREAM_ENABLE_UPDATE',
  METHOD_MOVESENSE_DEVICE_ENABLE_UPDATE = 'METHOD_MOVESENSE_DEVICE_ENABLE_UPDATE',
  METHOD_DEXCOM_INTEGRATION_ID_SET = 'METHOD_DEXCOM_INTEGRATION_ID_SET',
  METHOD_UPDATE_QUESTIONNAIRE = 'METHOD_UPDATE_QUESTIONNAIRE',
}

export const doMETHOD_SET = createAction(MethodActionType.METHOD_SET)
export const doMETHOD_DELETE = createAction(MethodActionType.METHOD_DELETE)
export const doMETHOD_ADD_TASK = createAction(MethodActionType.METHOD_ADD_TASK)
export const doMETHOD_UPDATE_TASK = createAction(MethodActionType.METHOD_UPDATE_TASK)
export const doMETHOD_UPDATE_TASK_SCHEDULE_LIST = createAction(MethodActionType.METHOD_UPDATE_TASK_SCHEDULE_LIST)
export const doMETHOD_ADD_TASK_SCHEDULE = createAction(MethodActionType.METHOD_ADD_TASK_SCHEDULE)
export const doMETHOD_UPDATE_TASK_SCHEDULE = createAction(MethodActionType.METHOD_UPDATE_TASK_SCHEDULE)
export const doMETHOD_UPDATE_TASK_SCHEDULE_REMINDER_LIST = createAction(
  MethodActionType.METHOD_UPDATE_TASK_SCHEDULE_REMINDER_LIST,
)
export const doMETHOD_DELETE_TASK_SCHEDULE = createAction(MethodActionType.METHOD_DELETE_TASK_SCHEDULE)
export const doMETHOD_ADD_TASK_EVENT_TRACKER = createAction(MethodActionType.METHOD_ADD_TASK_EVENT_TRACKER)
export const doMETHOD_UPDATE_TASK_EVENT_TRACKER = createAction(MethodActionType.METHOD_UPDATE_TASK_EVENT_TRACKER)
export const doMETHOD_DELETE_TASK_EVENT_TRACKER = createAction(MethodActionType.METHOD_DELETE_TASK_EVENT_TRACKER)
export const doMETHOD_UPDATE_TASK_ENABLE_STATUS = createAction(MethodActionType.METHOD_UPDATE_TASK_ENABLE_STATUS)
export const doMETHOD_DELETE_TASK = createAction(MethodActionType.METHOD_DELETE_TASK)
export const doMETHOD_TASK_LIST_UPDATE = createAction(MethodActionType.METHOD_TASK_LIST_UPDATE)
export const doMETHOD_TASK_LIST_ORDER_UPDATE = createAction(MethodActionType.METHOD_TASK_LIST_ORDER_UPDATE)
export const doMETHOD_GARMIN_CONNECT_ENABLE_UPDATE = createAction(MethodActionType.METHOD_GARMIN_CONNECT_ENABLE_UPDATE)
export const doMETHOD_GARMIN_STREAM_ENABLE_UPDATE = createAction(MethodActionType.METHOD_GARMIN_STREAM_ENABLE_UPDATE)
export const doMETHOD_MOVESENSE_DEVICE_ENABLE_UPDATE = createAction(
  MethodActionType.METHOD_MOVESENSE_DEVICE_ENABLE_UPDATE,
)
export const doMETHOD_DEXCOM_INTEGRATION_ID_SET = createAction(MethodActionType.METHOD_DEXCOM_INTEGRATION_ID_SET)
export const doMETHOD_UPDATE_QUESTIONNAIRE = createAction(MethodActionType.METHOD_UPDATE_QUESTIONNAIRE)
// interface IMethod {
//   id: string | null
//   identityId: string | null
//   workspaceId: string | null
//   projectId: string | null
//   garminConnectEnable: boolean
//   garminDeviceEnable: boolean
//   garminStreamEnable: boolean
//   movesenseDeviceEnable: boolean
//   dexcomIntegrationId?: string | null
//   updatedAt: string | null
//   createdAt: string | null
//   description: string | null
//   name: string | null
//   taskList: ITask[]
// }

interface RootState {
  method: IMethod
}

/* selector */
export const selectMethod = () => {
  return useSelector((state: RootState) => state.method)
}

export const methodActionCreators = {
  doMETHOD_SET,
  doMETHOD_DELETE,
  doMETHOD_ADD_TASK,
  doMETHOD_UPDATE_TASK,
  doMETHOD_UPDATE_TASK_ENABLE_STATUS,
  doMETHOD_DELETE_TASK,
  doMETHOD_TASK_LIST_UPDATE,
  doMETHOD_TASK_LIST_ORDER_UPDATE,
  doMETHOD_GARMIN_CONNECT_ENABLE_UPDATE,
  doMETHOD_GARMIN_STREAM_ENABLE_UPDATE,
  doMETHOD_MOVESENSE_DEVICE_ENABLE_UPDATE,
  doMETHOD_DEXCOM_INTEGRATION_ID_SET,
  doMETHOD_UPDATE_TASK_SCHEDULE_LIST,
  doMETHOD_ADD_TASK_SCHEDULE,
  doMETHOD_UPDATE_TASK_SCHEDULE,
  doMETHOD_UPDATE_TASK_SCHEDULE_REMINDER_LIST,
  doMETHOD_DELETE_TASK_SCHEDULE,
  doMETHOD_ADD_TASK_EVENT_TRACKER,
  doMETHOD_UPDATE_TASK_EVENT_TRACKER,
  doMETHOD_DELETE_TASK_EVENT_TRACKER,
  doMETHOD_UPDATE_QUESTIONNAIRE,
}

export const methodDefaultState: IMethod = {
  id: '',
  updatedAt: '',
  createdAt: '',
  workspaceId: '',
  projectId: '',
  description: '',
  garminConnectEnable: false,
  garminDeviceEnable: false,
  garminStreamEnable: false,
  movesenseDeviceEnable: false,
  dexcomIntegrationId: undefined,
  name: '',
  taskList: [],
}

type Action =
  | {
      type: MethodActionType.METHOD_SET
      payload: {
        id: string
        identityId: string
        workspaceId: string
        projectId: string
        garminConnectEnable: boolean
        garminDeviceEnable: boolean
        garminStreamEnable: boolean
        movesenseDeviceEnable: boolean
        dexcomIntegrationId?: string
        updatedAt: string
        createdAt: string
        description: string
        name: string
        taskList: ITask[]
      }
    }
  | {
      type: MethodActionType.METHOD_DELETE
      payload: undefined
    }
  | {
      type: MethodActionType.METHOD_ADD_TASK
      payload: ITask
    }
  | {
      type: MethodActionType.METHOD_UPDATE_TASK
      payload: ITask
    }
  | {
      type: MethodActionType.METHOD_UPDATE_TASK_SCHEDULE_LIST
      payload: {
        taskId: string
        scheduleList: ITaskSchedule[]
      }
    }
  | {
      type: MethodActionType.METHOD_ADD_TASK_SCHEDULE
      payload: ITaskSchedule
    }
  | {
      type: MethodActionType.METHOD_UPDATE_TASK_SCHEDULE
      payload: ITaskSchedule
    }
  | {
      type: MethodActionType.METHOD_UPDATE_TASK_SCHEDULE_REMINDER_LIST
      payload: {
        taskScheduleId: string
        reminderList: ITaskScheduleReminder[]
      }
    }
  | {
      type: MethodActionType.METHOD_DELETE_TASK_SCHEDULE
      payload: Pick<ITaskSchedule, 'id'>
    }
  | {
      type: MethodActionType.METHOD_ADD_TASK_EVENT_TRACKER
      payload: ITaskEventTracker
    }
  | {
      type: MethodActionType.METHOD_UPDATE_TASK_EVENT_TRACKER
      payload: ITaskEventTracker
    }
  | {
      type: MethodActionType.METHOD_DELETE_TASK_EVENT_TRACKER
      payload: Pick<ITaskEventTracker, 'id'>
    }
  | {
      type: MethodActionType.METHOD_UPDATE_TASK_ENABLE_STATUS
      payload: {
        taskId: string
        enabled: boolean
      }
    }
  | {
      type: MethodActionType.METHOD_DELETE_TASK
      payload: string
    }
  | {
      type: MethodActionType.METHOD_TASK_LIST_UPDATE
      payload: {
        taskList: ITask[]
      }
    }
  | {
      type: MethodActionType.METHOD_TASK_LIST_ORDER_UPDATE
      payload: {
        taskIdList: string[]
      }
    }
  | {
      type: MethodActionType.METHOD_GARMIN_CONNECT_ENABLE_UPDATE
      payload: {
        garminConnectEnable: boolean
      }
    }
  | {
      type: MethodActionType.METHOD_MOVESENSE_DEVICE_ENABLE_UPDATE
      payload: {
        movesenseDeviceEnable: boolean
      }
    } // TODO: combine all enable update method?
  | {
      type: MethodActionType.METHOD_GARMIN_STREAM_ENABLE_UPDATE
      payload: {
        garminStreamEnable: boolean
      }
    }
  | {
      type: MethodActionType.METHOD_DEXCOM_INTEGRATION_ID_SET
      payload: {
        dexcomIntegrationId: string
      }
    }
  | {
      type: MethodActionType.METHOD_UPDATE_QUESTIONNAIRE
      payload: IQuestionnaire
    }

export const methodReducer = (state = {...methodDefaultState}, {type, payload}: Action): IMethod => {
  switch (type) {
    case MethodActionType.METHOD_SET: {
      assertPartialSchema({
        payload,
        schema: v.object({
          id: v.string().uuid().exist(),
          identityId: v.string().uuid().optional().allow('', null),
          workspaceId: v.string().uuid().exist(),
          projectId: v.string().uuid().exist(),
          garminConnectEnable: v.boolean().exist(),
          garminDeviceEnable: v.boolean().exist(),
          garminStreamEnable: v.boolean().optional(), // TODO: production
          movesenseDeviceEnable: v.boolean().exist(),
          dexcomIntegrationId: v.string().optional().allow('', null),
          taskList: v.array().optional(),
          updatedAt: v.string().optional(),
          createdAt: v.string().optional(),
          description: v.string().optional().allow('', null),
          name: v.string().optional(),
        }),
      })
      return {...state, ...payload, dexcomIntegrationId: payload.dexcomIntegrationId ?? undefined}
    }

    case MethodActionType.METHOD_DELETE: {
      return methodDefaultState
    }

    case MethodActionType.METHOD_ADD_TASK: {
      assertPartialSchema({
        payload,
        schema: v.object(), // TODO: complete the schema include todo, timer, qn, garmin
      })
      const newTaskList = [...(state.taskList ?? []), payload]
      return {...state, taskList: newTaskList}
    }

    case MethodActionType.METHOD_UPDATE_TASK: {
      assertPartialSchema({
        payload,
        schema: v.object(), // TODO: complete the schema include todo, timer, qn, garmin
      })
      const newTaskList = [...(state.taskList ?? [])]
      const updateItemIndex = newTaskList.findIndex((item) => item.id === payload.id)
      newTaskList[updateItemIndex] = {...newTaskList[updateItemIndex], ...payload}
      return {...state, taskList: newTaskList}
    }
    case MethodActionType.METHOD_UPDATE_TASK_SCHEDULE_LIST: {
      const newTaskList = [...(state.taskList ?? [])]
      const updateItemIndex = newTaskList.findIndex((item) => item.id === payload.taskId)
      newTaskList[updateItemIndex] = {
        ...newTaskList[updateItemIndex],
        scheduleList: payload.scheduleList,
      }
      return {...state, taskList: newTaskList}
    }
    case MethodActionType.METHOD_UPDATE_TASK_ENABLE_STATUS: {
      assertPartialSchema({
        payload,
        schema: v.object({
          taskId: v.string().uuid().exist(),
          enabled: v.boolean().exist(),
        }),
      })
      const newTaskList = [...(state.taskList ?? [])]
      const updateItemIndex = newTaskList.findIndex((item) => item.id === payload.taskId)
      newTaskList[updateItemIndex] = {...newTaskList[updateItemIndex], enabled: payload.enabled}
      return {...state, taskList: newTaskList}
    }

    case MethodActionType.METHOD_DELETE_TASK: {
      assertPartialSchema({
        payload,
        schema: v.string().uuid(),
      })
      const newTaskList = [...(state.taskList ?? [])]
      const deleteItemIndex = newTaskList.findIndex((item) => item.id === payload)
      newTaskList.splice(deleteItemIndex, 1)
      return {...state, taskList: newTaskList}
    }

    case MethodActionType.METHOD_TASK_LIST_UPDATE: {
      assertPartialSchema({
        payload,
        schema: v.object({
          taskList: v.array().items(
            v.object(), // TODO: complete schema
          ),
        }),
      })

      return {...state, taskList: payload.taskList}
    }

    case MethodActionType.METHOD_TASK_LIST_ORDER_UPDATE: {
      assertPartialSchema({
        payload,
        schema: v.object({
          taskIdList: v.array().items(v.string().uuid()),
        }),
      })

      const taskList = reorderByPartialItems([...(state.taskList ?? [])], payload.taskIdList, (a, b) => a.id === b).map(
        (task, index) => ({...task, index}),
      )

      return {...state, taskList}
    }

    case MethodActionType.METHOD_GARMIN_CONNECT_ENABLE_UPDATE: {
      assertPartialSchema({
        payload,
        schema: v.object({
          garminConnectEnable: v.boolean().exist(),
        }),
      })

      return {...state, garminConnectEnable: payload.garminConnectEnable}
    }

    case MethodActionType.METHOD_MOVESENSE_DEVICE_ENABLE_UPDATE: {
      assertPartialSchema({
        payload,
        schema: v.object({
          movesenseDeviceEnable: v.boolean().exist(),
        }),
      })

      return {...state, movesenseDeviceEnable: payload.movesenseDeviceEnable}
    }

    case MethodActionType.METHOD_GARMIN_STREAM_ENABLE_UPDATE: {
      assertPartialSchema({
        payload,
        schema: v.object({
          garminStreamEnable: v.boolean().exist(),
        }),
      })

      return {...state, garminStreamEnable: payload.garminStreamEnable}
    }

    case MethodActionType.METHOD_DEXCOM_INTEGRATION_ID_SET: {
      assertPartialSchema({
        payload,
        schema: v.object({
          dexcomIntegrationId: v.string().exist().allow('', null),
        }),
      })

      return {...state, dexcomIntegrationId: payload.dexcomIntegrationId}
    }

    case MethodActionType.METHOD_ADD_TASK_SCHEDULE: {
      assertPartialSchema({
        payload,
        schema: v.object({
          id: v.string().exist(),
          taskId: v.string().exist(),
        }),
      })

      const newTaskList = [...(state.taskList ?? [])]
      const taskIndex = newTaskList.findIndex(({id}) => id === payload.taskId)
      if (taskIndex !== -1) {
        const task = newTaskList[taskIndex]
        newTaskList[taskIndex] = {
          ...task,
          scheduleList: [...(task.scheduleList ?? []), payload],
        }
      }

      return {...state, taskList: newTaskList}
    }

    case MethodActionType.METHOD_UPDATE_TASK_SCHEDULE: {
      assertPartialSchema({
        payload,
        schema: v.object({
          id: v.string().exist(),
          taskId: v.string().exist(),
        }),
      })
      const newTaskList = [...(state.taskList ?? [])]
      const taskIndex = newTaskList.findIndex(({id}) => id === payload.taskId)
      if (taskIndex !== -1) {
        const task = newTaskList[taskIndex]
        const scheduleIndex = (task.scheduleList ?? []).findIndex(({id}) => id === payload.id)
        if (scheduleIndex !== -1) {
          newTaskList[taskIndex] = {
            ...task,
            scheduleList: (task.scheduleList ?? []).map((schedule, index) =>
              index === scheduleIndex ? payload : schedule,
            ),
          }
        }
      }

      return {...state, taskList: newTaskList}
    }

    case MethodActionType.METHOD_UPDATE_TASK_SCHEDULE_REMINDER_LIST: {
      assertPartialSchema({
        payload,
        schema: v.object({
          taskScheduleId: v.string().exist(),
          reminderList: v.array().exist(),
        }),
      })

      const newTaskList = [...(state.taskList ?? [])]
      for (const task of newTaskList) {
        const newScheduleList = [...(task.scheduleList ?? [])]
        const scheduleIndex = newScheduleList.findIndex(({id}) => id === payload.taskScheduleId)
        if (scheduleIndex > -1) {
          newScheduleList[scheduleIndex] = {
            ...newScheduleList[scheduleIndex],
            reminderList: payload.reminderList,
          }
          task.scheduleList = newScheduleList
          break
        }
      }

      return {...state, taskList: newTaskList}
    }

    case MethodActionType.METHOD_DELETE_TASK_SCHEDULE: {
      assertPartialSchema({
        payload,
        schema: v.object({
          id: v.string().exist(),
        }),
      })

      const newTaskList = [...(state.taskList ?? [])]
      const taskIndex = newTaskList.findIndex(({scheduleList}) =>
        (scheduleList ?? []).some(({id}) => id === payload.id),
      )
      if (taskIndex !== -1) {
        const task = newTaskList[taskIndex]
        newTaskList[taskIndex] = {
          ...task,
          scheduleList: (task.scheduleList ?? []).filter(({id}) => id !== payload.id),
        }
      }

      return {...state, taskList: newTaskList}
    }

    case MethodActionType.METHOD_ADD_TASK_EVENT_TRACKER: {
      assertPartialSchema({
        payload,
        schema: v.object({
          id: v.string().exist(),
          taskId: v.string().exist(),
        }),
      })

      const newTaskList = [...(state.taskList ?? [])]
      const taskIndex = newTaskList.findIndex(({id}) => id === payload.taskId)
      if (taskIndex !== -1) {
        newTaskList[taskIndex] = {
          ...newTaskList[taskIndex],
          eventTracker: payload,
        }
      }

      return {...state, taskList: newTaskList}
    }

    case MethodActionType.METHOD_UPDATE_TASK_EVENT_TRACKER: {
      assertPartialSchema({
        payload,
        schema: v.object({
          id: v.string().exist(),
          taskId: v.string().exist(),
        }),
      })

      const newTaskList = [...(state.taskList ?? [])]
      const taskIndex = newTaskList.findIndex(({id}) => id === payload.taskId)
      if (taskIndex !== -1) {
        newTaskList[taskIndex] = {
          ...newTaskList[taskIndex],
          eventTracker: payload,
        }
      }

      return {...state, taskList: newTaskList}
    }

    case MethodActionType.METHOD_DELETE_TASK_EVENT_TRACKER: {
      assertPartialSchema({
        payload,
        schema: v.object({
          id: v.string().exist(),
        }),
      })

      const newTaskList = [...(state.taskList ?? [])]
      const taskIndex = newTaskList.findIndex((task) => task.eventTracker?.id === payload.id)
      if (taskIndex !== -1) {
        newTaskList[taskIndex] = {
          ...newTaskList[taskIndex],
          eventTracker: undefined,
        }
      }

      return {...state, taskList: newTaskList}
    }

    case MethodActionType.METHOD_UPDATE_QUESTIONNAIRE: {
      assertPartialSchema({
        payload,
        schema: v.object(),
      })
      const newTaskList = [...(state.taskList ?? [])]
      const updateItemIndex = newTaskList.findIndex(
        (item) => item.id === payload.taskId && item.type === 'questionnaire',
      )
      if (updateItemIndex !== -1) {
        newTaskList[updateItemIndex] = {
          ...newTaskList[updateItemIndex],
          questionnaire: {
            ...payload,
          },
        }
      }
      return {...state, taskList: newTaskList}
    }
    default:
      return state
  }
}
